"use strict";

var _slicedToArray = require("/Users/chengluyu/Developer/anichart-marker/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var _classCallCheck = require("/Users/chengluyu/Developer/anichart-marker/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/chengluyu/Developer/anichart-marker/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/Users/chengluyu/Developer/anichart-marker/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/Users/chengluyu/Developer/anichart-marker/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _get = require("/Users/chengluyu/Developer/anichart-marker/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/get");

var _inherits = require("/Users/chengluyu/Developer/anichart-marker/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var solver_1 = require("../../solver");

var Specification = require("../../specification");

var line_attrs_1 = require("./line.attrs");

var Graphics = require("../../graphics");

var emphasis_1 = require("./emphasis");

var LineElementClass =
/*#__PURE__*/
function (_emphasis_1$Emphasiza) {
  _inherits(LineElementClass, _emphasis_1$Emphasiza);

  function LineElementClass() {
    var _this;

    _classCallCheck(this, LineElementClass);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(LineElementClass).apply(this, arguments));
    _this.attributes = line_attrs_1.lineAttributes;
    _this.attributeNames = Object.keys(line_attrs_1.lineAttributes);
    return _this;
  } // Initialize the state of an element so that everything has a valid value


  _createClass(LineElementClass, [{
    key: "initializeState",
    value: function initializeState() {
      _get(_getPrototypeOf(LineElementClass.prototype), "initializeState", this).call(this);

      var defaultWidth = 30;
      var defaultHeight = 50;
      var attrs = this.state.attributes;
      attrs.x1 = -defaultWidth / 2;
      attrs.y1 = -defaultHeight / 2;
      attrs.x2 = +defaultWidth / 2;
      attrs.y2 = +defaultHeight / 2;
      attrs.cx = 0;
      attrs.cy = 0;
      attrs.dx = 0;
      attrs.dy = 0;
      attrs.stroke = {
        r: 0,
        g: 0,
        b: 0
      };
      attrs.strokeWidth = 1;
      attrs.opacity = 1;
      attrs.visible = true;
    } // Get intrinsic constraints between attributes (e.g., x2 - x1 = width for rectangles)

  }, {
    key: "buildConstraints",
    value: function buildConstraints(solver) {
      var _solver$attrs = solver.attrs(this.state.attributes, ["x1", "y1", "x2", "y2", "cx", "cy", "dx", "dy"]),
          _solver$attrs2 = _slicedToArray(_solver$attrs, 8),
          x1 = _solver$attrs2[0],
          y1 = _solver$attrs2[1],
          x2 = _solver$attrs2[2],
          y2 = _solver$attrs2[3],
          cx = _solver$attrs2[4],
          cy = _solver$attrs2[5],
          dx = _solver$attrs2[6],
          dy = _solver$attrs2[7];

      solver.addLinear(solver_1.ConstraintStrength.HARD, 0, [[2, cx]], [[1, x1], [1, x2]]);
      solver.addLinear(solver_1.ConstraintStrength.HARD, 0, [[2, cy]], [[1, y1], [1, y2]]);
      solver.addLinear(solver_1.ConstraintStrength.HARD, 0, [[1, dx]], [[1, x2], [-1, x1]]);
      solver.addLinear(solver_1.ConstraintStrength.HARD, 0, [[1, dy]], [[1, y2], [-1, y1]]);
    } // Get the graphical element from the element

  }, {
    key: "getGraphics",
    value: function getGraphics(cs, offset) {
      var glyphIndex = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
      var manager = arguments.length > 3 ? arguments[3] : undefined;
      var emphasize = arguments.length > 4 ? arguments[4] : undefined;
      var attrs = this.state.attributes;

      if (!attrs.visible || !this.object.properties.visible) {
        return null;
      }

      var helper = new Graphics.CoordinateSystemHelper(cs);
      return helper.line(attrs.x1 + offset.x, attrs.y1 + offset.y, attrs.x2 + offset.x, attrs.y2 + offset.y, Object.assign({
        strokeColor: attrs.stroke,
        strokeOpacity: attrs.opacity,
        strokeWidth: attrs.strokeWidth
      }, this.generateEmphasisStyle(emphasize)));
    } // Get DropZones given current state

  }, {
    key: "getDropZones",
    value: function getDropZones() {
      var attrs = this.state.attributes;
      var x1 = attrs.x1,
          y1 = attrs.y1,
          x2 = attrs.x2,
          y2 = attrs.y2;
      var cx = x1;
      var cy = y1;
      return [{
        type: "line",
        p1: {
          x: x2,
          y: cy
        },
        p2: {
          x: x1,
          y: cy
        },
        title: "dx",
        accept: {
          kind: "numerical"
        },
        dropAction: {
          scaleInference: {
            attribute: "dx",
            attributeType: "number",
            hints: {
              autoRange: true,
              startWithZero: "always"
            }
          }
        }
      }, {
        type: "line",
        p1: {
          x: cx,
          y: y1
        },
        p2: {
          x: cx,
          y: y2
        },
        title: "dy",
        accept: {
          kind: "numerical"
        },
        dropAction: {
          scaleInference: {
            attribute: "dy",
            attributeType: "number",
            hints: {
              autoRange: true,
              startWithZero: "always"
            }
          }
        }
      }];
    } // Get bounding rectangle given current state

  }, {
    key: "getHandles",
    value: function getHandles() {
      var attrs = this.state.attributes;
      var x1 = attrs.x1,
          y1 = attrs.y1,
          x2 = attrs.x2,
          y2 = attrs.y2,
          cx = attrs.cx,
          cy = attrs.cy;
      return [{
        type: "point",
        x: x1,
        y: y1,
        actions: [{
          type: "attribute",
          source: "x",
          attribute: "x1"
        }, {
          type: "attribute",
          source: "y",
          attribute: "y1"
        }]
      }, {
        type: "point",
        x: x2,
        y: y2,
        actions: [{
          type: "attribute",
          source: "x",
          attribute: "x2"
        }, {
          type: "attribute",
          source: "y",
          attribute: "y2"
        }]
      }, {
        type: "point",
        x: cx,
        y: cy,
        actions: [{
          type: "attribute",
          source: "x",
          attribute: "cx"
        }, {
          type: "attribute",
          source: "y",
          attribute: "cy"
        }]
      }];
    }
  }, {
    key: "getBoundingBox",
    value: function getBoundingBox() {
      var attrs = this.state.attributes;
      var x1 = attrs.x1,
          y1 = attrs.y1,
          x2 = attrs.x2,
          y2 = attrs.y2;
      return {
        type: "line",
        morphing: true,
        x1: x1,
        y1: y1,
        x2: x2,
        y2: y2
      };
    }
  }, {
    key: "getSnappingGuides",
    value: function getSnappingGuides() {
      var attrs = this.state.attributes;
      var x1 = attrs.x1,
          y1 = attrs.y1,
          x2 = attrs.x2,
          y2 = attrs.y2,
          cx = attrs.cx,
          cy = attrs.cy;
      return [{
        type: "x",
        value: x1,
        attribute: "x1"
      }, {
        type: "x",
        value: x2,
        attribute: "x2"
      }, {
        type: "x",
        value: cx,
        attribute: "cx"
      }, {
        type: "y",
        value: y1,
        attribute: "y1"
      }, {
        type: "y",
        value: y2,
        attribute: "y2"
      }, {
        type: "y",
        value: cy,
        attribute: "cy"
      }];
    }
  }, {
    key: "getAttributePanelWidgets",
    value: function getAttributePanelWidgets(manager) {
      return [manager.sectionHeader("Line"), manager.mappingEditor("X Span", "dx", {
        hints: {
          autoRange: true,
          startWithZero: "always"
        },
        acceptKinds: [Specification.DataKind.Numerical],
        defaultAuto: true
      }), manager.mappingEditor("Y Span", "dy", {
        hints: {
          autoRange: true,
          startWithZero: "always"
        },
        acceptKinds: [Specification.DataKind.Numerical],
        defaultAuto: true
      }), manager.sectionHeader("Style"), manager.mappingEditor("Stroke", "stroke", {}), manager.mappingEditor("Line Width", "strokeWidth", {
        hints: {
          rangeNumber: [0, 5]
        },
        defaultValue: 1,
        numberOptions: {
          showSlider: true,
          sliderRange: [0, 5],
          minimum: 0
        }
      }), manager.mappingEditor("Opacity", "opacity", {
        hints: {
          rangeNumber: [0, 1]
        },
        defaultValue: 1,
        numberOptions: {
          showSlider: true,
          minimum: 0,
          maximum: 1
        }
      }), manager.mappingEditor("Visibility", "visible", {
        defaultValue: true
      })];
    }
  }]);

  return LineElementClass;
}(emphasis_1.EmphasizableMarkClass);

LineElementClass.classID = "mark.line";
LineElementClass.type = "mark";
LineElementClass.metadata = {
  displayName: "Line",
  iconPath: "mark/line",
  creatingInteraction: {
    type: "line-segment",
    mapping: {
      x1: "x1",
      y1: "y1",
      x2: "x2",
      y2: "y2"
    }
  }
};
LineElementClass.defaultProperties = {
  visible: true
};
LineElementClass.defaultMappingValues = {
  stroke: {
    r: 0,
    g: 0,
    b: 0
  },
  strokeWidth: 1,
  opacity: 1,
  visible: true
};
exports.LineElementClass = LineElementClass;